module.exports = __webpack_public_path__ + "assets/profile2.fb90aab4.svg";